import React from "react"
import { InputText } from "primereact/inputtext"
import { Field } from "formik"

import styles from "../../styles/Form.module.css"

export default function TypeEmail(props) {
  const { fieldname, label, description, editMode } = props
  return (
    <Field name={fieldname}>
      {({ field, meta }) => {
        return (
          <div className={styles.field}>
            <label htmlFor={fieldname} className={styles.label}>
              {label}
            </label>
            {description && (
              <small style={{ display: "block", marginBottom: 10 }}>
                {description}
              </small>
            )}
            <InputText
              id={fieldname}
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              disabled={editMode}
            />
            {meta.touched && meta.error && (
              <div className={styles.error}>{meta.error}</div>
            )}
          </div>
        )
      }}
    </Field>
  )
}
